const lengthOptionsLabels = {
    'full-day': 'Egésznapos',
    'multi-day': 'Több napos',
}

const getReservationDateLabel = (r) => {
    const lengthOptions = r?.price?.service?.length_options
    if (lengthOptions === 'full-day') return `${r?.date} (${lengthOptionsLabels['full-day']})`
    if (lengthOptions === 'multi-day') return `${r?.date} - ${r?.end_date} (${lengthOptionsLabels['multi-day']})`
    return `${r?.date} | ${r?.start_time} - ${r?.end_time}`
}

export {lengthOptionsLabels, getReservationDateLabel}
